import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class Activate {

    constructor (private http: HttpClient) {}

    activateEmail(key: string): Observable<any> {
        let params = new HttpParams().set('key', key);
        return this.http.get('/api/activate-email', {
            params: params
        });
    }

    activateAccount(key: string): Observable<any> {
        let params = new HttpParams().set('key', key);

        return this.http.get('/api/activate-account', {
            params: params
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/activate/activate.service.ts